"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataSet = void 0;
var DataSet = /** @class */ (function () {
    function DataSet(dataSet) {
        this.items = dataSet.items;
        this.from = dataSet.from;
        this.to = dataSet.to;
        this.totalLength = dataSet.totalLength;
        this.atEnd = dataSet.atEnd;
    }
    return DataSet;
}());
exports.DataSet = DataSet;
//# sourceMappingURL=DataSet.js.map